
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalProps } from 'reactstrap';
import Button from './button';

interface MessageModalProps extends Omit<ModalProps, 'toggle'> {
  titleText: string;
  buttonText?: string;
  children: React.ReactNode;
  toggle: () => void;
}

const MessageModal = (props: MessageModalProps) => {
  const { titleText, buttonText = 'Close', children, toggle, ...modalProps } = props;

  return (
    <Modal {...modalProps} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle} tag={'h2'}>
        {titleText}
      </ModalHeader>
      <ModalBody>
        {children}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          {buttonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default MessageModal;
